import { GetCurrentSchoolYearUseCase } from '@/pages/mission/use-cases/get-current-school-year';
import { ReportingToolsPage } from '@edwin-group/cj-graphql';
import { startTransition } from 'react';
import { create } from 'zustand';

interface ReportingToolsState {
  filters: {
    academicYear: string;
    cohortDocumentIds: string[];
    schoolDocumentIds: string[];
  };
  dialogData: {
    title: string;
    description: string;
  };
  page: ReportingToolsPage | null;
  openDialog: boolean;
  updateFilters: (filters: ReportingToolsState['filters']) => void;
  onOpenDialog: (dialogData: ReportingToolsState['dialogData']) => void;
}

export const useReportingToolsStore = create<ReportingToolsState>((set) => ({
  filters: {
    academicYear: GetCurrentSchoolYearUseCase.execute(),
    cohortDocumentIds: [],
    schoolDocumentIds: [],
  },
  dialogData: {
    title: '',
    description: '',
  },
  page: null,
  openDialog: false,
  onOpenDialog: (dialogData: ReportingToolsState['dialogData']) => set({ dialogData, openDialog: true }),
  updateFilters: (filters: ReportingToolsState['filters']) => {
    startTransition(() => {
      set((state) => ({
        filters: {
          ...state.filters,
          ...filters,
        },
      }));
    });
  },
}));
